// Define sendCartGTMItems in the global scope
window.sendCartGTMItems = function (eventName, variant_id, quantity, product_url, handle, callback) {
	let section_url = "/cart?section_id=api-gtm-cart-items";
	let removed = false;
	if (product_url) {
		section_url = product_url + "&section_id=api-gtm-select-item";
		removed = true;
	}

	return fetch(section_url)
		.then((res) => res.text())
		.then((html) => {
			try {
				const jsonElement = new DOMParser().parseFromString(html, "text/html").querySelector("#line-items-json");

				if (!jsonElement) return null;

				const jsonData = JSON.parse(JSON.parse(jsonElement.textContent.trim()));

				if (eventName) jsonData.event = eventName;
				jsonData.ecommerce.currency = getCurrentCurrency();

				if (!removed) {
					if (variant_id && quantity) {
						jsonData.ecommerce.items = jsonData.ecommerce.items.filter((item) => item.item_id === variant_id);
						jsonData.ecommerce.items[0].quantity = quantity;
						jsonData.ecommerce.value = (parseFloat(jsonData.ecommerce.items[0].price) * parseInt(quantity)).toFixed(2) + "";
					}
				} else {
					delete jsonData.ecommerce.item_list_id;
					delete jsonData.ecommerce.item_list_name;

					jsonData.ecommerce.items[0].coupon = "";
					jsonData.ecommerce.items[0].item_list_id = "";
					jsonData.ecommerce.items[0].item_list_name = "cart";
					jsonData.ecommerce.items[0].location_id = "";
					jsonData.ecommerce.items[0].quantity = quantity;

					jsonData.ecommerce.value = (parseFloat(jsonData.ecommerce.items[0].price) * parseInt(quantity)).toFixed(2) + "";
				}

				callback?.(jsonData);
				Shopify?.analytics?.publish?.(`custom_${eventName}`, jsonData);

				return jsonData;
			} catch (err) {
				console.warn("sendCartGTMItems: parsing error", err);
				return null;
			}
		})
		.catch((err) => {
			console.warn("sendCartGTMItems: fetch error", err);
			return null;
		});
};

// Define sendAddToWishListGTM in the global scope
window.sendAddToWishListGTM = function (eventName, product_url, item_list_name, callback) {
	const sectionId = "api-gtm-product-items";
	const separator = product_url.includes("?") ? "&" : "?";
	const url = `${product_url}${separator}section_id=${sectionId}`;

	return fetch(url)
		.then((res) => res.text())
		.then((html) => {
			try {
				const jsonElement = new DOMParser().parseFromString(html, "text/html").querySelector("#line-items-json");

				if (!jsonElement) throw new Error("No JSON element found");

				const jsonData = JSON.parse(JSON.parse(jsonElement.textContent.trim()));

				if (eventName) jsonData.event = eventName;
				if (item_list_name) jsonData.ecommerce.items[0].item_list_name = item_list_name;
				jsonData.ecommerce.items[0].currency = getCurrentCurrency();

				callback?.(jsonData);
				Shopify?.analytics?.publish?.(`${eventName}`, jsonData);

				return jsonData;
			} catch (err) {
				console.warn("sendAddToWishListGTM: parsing error", err);
				return null;
			}
		})
		.catch((err) => {
			console.warn("sendAddToWishListGTM: fetch error", err);
			return null;
		});
};

// Define sendProductGTMItems in the global scope
window.sendProductGTMItems = function (eventName, product_url, item_list_name, callback) {
	const sectionId = "api-gtm-product-items";
	const separator = product_url.includes("?") ? "&" : "?";
	const url = `${product_url}${separator}section_id=${sectionId}`;

	return fetch(url)
		.then((res) => res.text())
		.then((html) => {
			try {
				const jsonElement = new DOMParser().parseFromString(html, "text/html").querySelector("#line-items-json");

				if (!jsonElement) throw new Error("No JSON element found");

				const jsonData = JSON.parse(JSON.parse(jsonElement.textContent.trim()));

				if (eventName) jsonData.event = eventName;
				if (item_list_name) jsonData.ecommerce.items[0].item_list_name = item_list_name;
				jsonData.ecommerce.items[0].currency = getCurrentCurrency();

				callback?.(jsonData);
				Shopify?.analytics?.publish?.(`custom_${eventName}`, jsonData);

				return jsonData;
			} catch (err) {
				console.warn("sendProductGTMItems: parsing error", err);
				return null;
			}
		})
		.catch((err) => {
			console.warn("sendProductGTMItems: fetch error", err);
			return null;
		});
};

// Define send Selected Item GTM
window.sendSelectedItemGTMItems = function (eventName, product_url, item_list_name) {
	const sectionId = "api-gtm-select-item";
	let productSectionUrl = product_url.includes("?variant=") ? product_url + `&section_id=${sectionId}` : product_url + `?section_id=${sectionId}`;

	return fetch(productSectionUrl)
		.then((response) => response.text())
		.then((text) => {
			const sectionInnerHTML = new DOMParser().parseFromString(text, "text/html").querySelector(".shopify-section");

			if (!sectionInnerHTML) throw new Error("No section found");

			const jsonElement = sectionInnerHTML.querySelector("#line-items-json");
			if (!jsonElement) throw new Error("No JSON element found");

			const jsonText = jsonElement.textContent.trim();
			const jsonData = JSON.parse(JSON.parse(jsonText));

			if (eventName) jsonData.event = eventName;
			if (item_list_name) jsonData.ecommerce.item_list_name = item_list_name;

			if (window.Shopify && window.Shopify.analytics) {
				Shopify.analytics.publish(`custom_${eventName}`, jsonData);
			}

			return jsonData;
		});
};

// Define getCollectionGTMItems in the global scope
window.sendCollectionGTMItems = function (eventName, handle, callback) {
	const url = `/collections/${handle}?section_id=api-gtm-item-list`;

	return fetch(url)
		.then((res) => res.text())
		.then((html) => {
			try {
				const jsonElement = new DOMParser().parseFromString(html, "text/html").querySelector("#line-items-json");

				if (!jsonElement) throw new Error("No JSON element found");

				const jsonData = JSON.parse(JSON.parse(jsonElement.textContent.trim()));

				if (eventName) jsonData.event = eventName;
				callback?.(jsonData);
				Shopify?.analytics?.publish?.(`custom_${eventName}`, jsonData);

				return jsonData;
			} catch (err) {
				console.warn("sendCollectionGTMItems: parsing error", err);
				return null;
			}
		})
		.catch((err) => {
			console.warn("sendCollectionGTMItems: fetch error", err);
			return null;
		});
};

// Define getNewsletterGTMPopup in the global scope
window.sendNewsletterGTMPopup = function (eventName) {
	try {
		const jsonData = {
			event: "select_content",
			event_category: "homepage",
			event_action: "newsletter",
			event_label: "display",
		};

		Shopify?.analytics?.publish?.(`custom_${eventName}`, jsonData);

		return Promise.resolve(jsonData);
	} catch (err) {
		console.warn("sendNewsletterGTMPopup: error", err);
		return Promise.resolve(null); // ne bloque jamais
	}
};

// Define getNewsletterGTMSubscription in the global scope
window.sendNewsletterGTMSubscription = function (eventName) {
	try {
		const jsonData = {
			event: "select_content",
			event_category: "homepage",
			event_action: "newsletter",
			event_label: "subscribe",
		};

		Shopify?.analytics?.publish?.(`custom_${eventName}`, jsonData);

		return Promise.resolve(jsonData);
	} catch (err) {
		console.warn("sendNewsletterGTMSubscription: error", err);
		return Promise.resolve(null);
	}
};

//PAGE VIEW   (dispatch on all pages)
window.sendPageViewGTM = function (pageType, pageName, locale, customerId, customerEmail, customObject = {}) {
	try {
		const data = {
			page_location: document.location.href,
			page_referrer: document.referrer,
			page_title: document.title,
			country_name: window.Shopify?.country || "",
			language: locale,
			environnement_type: "prod",
		};

		if (customerId) {
			data.customer_id = customerId;
			data.customer_email = customerEmail;
		}

		switch (pageType) {
			case "index":
				Object.assign(data, {
					page_type: "homepage",
					page_name: "",
					page_category: "homepage",
					sub_category: "",
					univers_type: "content",
				});
				break;

			case "page":
				if (["sur-mesure", "demi-mesure"].includes(pageName)) {
					Object.assign(data, {
						page_type: "experiences",
						page_name: "",
						page_category: "personnalisation",
						sub_category: pageName,
						univers_type: "e shop",
					});
				} else if (pageName === "wishlist") {
					Object.assign(data, {
						page_type: "wishlist",
						page_name: "",
						page_category: "",
						sub_category: "",
						univers_type: "e shop",
					});
				} else {
					Object.assign(data, {
						page_type: customObject.page_type || "content_page",
						page_name: "",
						page_category: customObject.page_category || "",
						sub_category: pageName,
						univers_type: "content",
					});
				}
				break;

			case "search":
				Object.assign(data, {
					page_type: "search_page / result_page",
					page_name: "",
					page_category: "",
					sub_category: "",
					univers_type: "e shop",
				});
				break;

			default:
				if (pageType.startsWith("customers/")) {
					Object.assign(data, {
						page_type: "customer_account",
						page_name: "",
						page_category: pageType.split("/")[1],
						sub_category: "",
						univers_type: "account",
					});
				} else if (pageType === "product") {
					Object.assign(data, {
						page_type: pageType,
						page_name: customObject.title || "",
						page_category: customObject.category || "",
						sub_category: customObject.subcategory || "",
						univers_type: "e shop",
					});
				} else if (pageType === "collection") {
					Object.assign(data, {
						page_type: pageType,
						page_name: customObject.title || "",
						page_category: "",
						sub_category: "",
						univers_type: "e shop",
					});
				} else {
					Object.assign(data, {
						page_type: pageType,
						page_name: pageName,
						page_category: "",
						sub_category: "",
						univers_type: "e shop",
					});
				}
		}

		Shopify?.analytics?.publish?.("page_view", data);
		return Promise.resolve(data);
	} catch (err) {
		console.warn("sendPageViewGTM: error", err);
		return Promise.resolve(null);
	}
};

// Listen to click events on links and send GTM events for product links
window.listenToClick = function () {
	document.addEventListener("click", (event) => {
		const link = event.target.closest("a[href]");
		if (!link) return;

		// Ignore les clics spéciaux (nouvel onglet, modifieurs...)
		if (link.target === "_blank" || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) {
			return;
		}

		const isInternal = link.hostname === window.location.hostname;
		const isProductLink = link.href.includes("/products/");
		if (!isInternal || !isProductLink) return;

		event.preventDefault();

		// Déduction du contexte (page_location)
		const path = window.location.pathname;
		const target = event.target;
		let page_location = "";

		if (target.closest(".search__results")) {
			page_location = "search results";
		} else if (path.includes("/collections/")) {
			page_location = "plp";
		} else if (path.includes("/products/")) {
			if (target.closest(".main-product-recommendation-item")) {
				page_location = "cross sell";
			} else if (target.closest(".product-card")) {
				page_location = "pdp-product-recommendation";
			} else {
				page_location = "pdp";
			}
		} else if (path === "/search") {
			page_location = "search page";
		} else if (path === "/") {
			page_location = "homepage";
		}

		// Nettoyage de l’URL produit (garde uniquement le paramètre `variant`)
		const url = new URL(link.href);
		const variant = url.searchParams.get("variant");
		let productUrl = url.pathname;

		if (variant) productUrl += `?variant=${variant}`;

		// Envoi de l’événement + redirection
		window.sendSelectedItemGTMItems("select_item", productUrl, page_location).finally(() => (window.location.href = link.href));
	});
};

/* HELPERS */
function getCurrentCurrency() {
	let currency = window.Shopify?.currency?.active || "EUR";

	return currency.toUpperCase();
}
